module.exports = __webpack_public_path__ + "media/images/gallery/search_on-b236d9e47c41181bfec36b0cfd247218.gif";